const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

async function request(endpoint, options = {}) {
  const res = await fetch(`${API_BASE}${endpoint}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'خطأ');
  return data;
}

// Public product endpoints
export const getProducts = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return request(`/products${query ? `?${query}` : ''}`);
};
 export const getCategories = () => request('/categories');
 
export const getProductBySlug = (slug) => request(`/products/${slug}`);

// Orders (public)
export const placeOrder = (orderData) =>
  request('/orders', {
    method: 'POST',
    body: JSON.stringify(orderData),
  });

export const trackOrder = (phone, order_id) =>
  request(`/orders/track?phone=${encodeURIComponent(phone)}&order_id=${order_id}`);